import clsx from 'clsx';
import * as React from 'react';

import { TextSkeleton } from '@gitbook/spine-react';

/**
 * Utility to highlight a group of pages in the table of contents.
 */
export const PageGroupHighlight = React.forwardRef(function PageGroupHighlight(
    props: React.ComponentPropsWithoutRef<'div'> & { isActive?: boolean; isDisabled?: boolean },
    ref: React.ForwardedRef<HTMLDivElement>
) {
    const { children, isActive, isDisabled, ...rest } = props;
    return (
        <div
            ref={ref}
            {...rest}
            data-active={isActive || undefined}
            data-disabled={isDisabled || undefined}
            className={clsx('group relative', rest.className)}
        >
            <div
                className={clsx(
                    '-inset-px pointer-events-none absolute right-0 rounded border border-dashed group-hover:border-[--sp-color-border-block-reference-frame-active]',
                    'transition-colors',
                    'border-transparent group-data-[active]:border-[--sp-color-border-block-reference-frame-active]',
                    'group-data-[disabled]:border-transparent'
                )}
            />
            {children}
        </div>
    );
});

/**
 * Header of an highlighted group.
 */
export function PageGroupHighlightHeader(props: React.ComponentPropsWithoutRef<'div'>) {
    return (
        <div
            {...props}
            className={clsx(
                '-translate-y-[50%] absolute top-0 right-3 z-10 select-none transition-opacity',
                'opacity-0 group-hover:opacity-100 group-data-[active]:opacity-100',
                'group-data-[disabled]:opacity-0',
                props.className
            )}
        />
    );
}

/**
 * Loading state for a highlighted group.
 */
export function PageGroupHighlightLoadingState() {
    return (
        <div className="px-4 py-2">
            <TextSkeleton className="text-ui-base">Loading Page</TextSkeleton>
        </div>
    );
}
